<template>
  <master-layout :enable-scroll-event="true">
    <div
      v-if="isLoading || !update"
      class="p-[16px] fixed top-0 start-0 w-full h-full bg-white/90 z-1000 flex items-center justify-center"
    >
      <Loading />
    </div>
    <div
      v-else
      class="mx-[24px] md:mx-[32px] lg:ml-[56px] pt-8 mb-[20px] md:mt-[40px]"
      :class="{ 'pt-[92px]': isIos() }"
    >
      <BackButton compact fallback-route="/updates" />
    </div>

    <section class="mx-[24px] md:mx-[32px] lg:ml-[56px] font-aktiv-grotesk font-bold">
      <h4 class="text-[1.5rem] leading-[2rem] mb-[4px] text-black md:mb-[32px]">
        {{ update.title }}
      </h4>
    </section>
    <div class="mx-6 md:mx-[32px] lg:mx-[56px]">
      <div v-if="update.postedTime != ''" class="flex justify-end font-aktiv-grotesk">
        <p class="tracking-wide text-xs text-grey-100">
          {{ formatPostedTime(update.postedTime) }}
        </p>
      </div>
      <div>
        <div class="mb-3 font-aktiv-grotest-regular">
          <p
            class="tracking-wide text-[1rem] leading-[1.5rem] pr-3 text-grey-100 font-aktiv-grotesk"
          >
            <html-to-vue :html="update.descriptionFull" />
          </p>
        </div>
      </div>
    </div>
  </master-layout>
</template>

<script>
import { mapState } from 'vuex';
import BackButton from '@/components/common/BackButton';
import { isIosNativeOnly } from '@/utils/platform-check';
import { formatPostedTime } from '@/utils/date';
import Loading from '@/components/common/LoadingState.vue';

export default {
  name: 'UpdatesDetailsPage',
  components: {
    BackButton,
    Loading,
  },
  data() {
    return {
      update: null,
      isLoading: false,
    };
  },
  computed: {
    ...mapState('updates', ['updates']),
  },
  async ionViewWillEnter() {
    const updateId = this.$route.params.id;

    // Check if update already exists in store
    const existingUpdate = this.updates?.find(u => u.id == updateId);

    if (existingUpdate) {
      // Data already exists, no loading flash
      this.update = existingUpdate;
      // Mark as read in background
      this.$store.dispatch('updates/markReadUpdate', updateId);
      return;
    }

    // Data not in store, show loading and fetch
    try {
      this.isLoading = true;
      await this.$store.dispatch('updates/getUpdates', 'all');
      await this.$store.dispatch('updates/markReadUpdate', updateId);
      for (let i = 0; i < this.updates.length; i++) {
        if (this.updates[i].id == updateId) {
          this.update = this.updates[i];
        }
      }
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    isIos() {
      return isIosNativeOnly();
    },
    formatPostedTime(time) {
      return formatPostedTime(time, { verbose: true });
    },
  },
};
</script>
